<template>
<div class="as-home-banner-m display-mobile">
  <header>

    <section class="banner-top">
      <img  class="banner-bg" src="./assets/banner-m-bg.png" alt="">
      <div class="banner-info">
        <div class="banner-info__logo"><img :src="bannerLogo" alt=""></div>
        <p class="banner-info__location">
          {{`&lt; ${conInfo.year} ⋅ ${conInfo.locationCN}站 &gt;`}}
        </p>
        <div class="banner-info__key">
          <div class="banner-info__time">
            <p class="banner-info__conftime">{{`会议：${conInfo.conTime}`}}</p>
            <p v-if="conInfo.trainingTime">{{`培训：${conInfo.trainingTime}`}}</p>
          </div>
          <p>{{conInfo.address}}</p>
        </div>
        <div class="banner-info__btn">
          <!-- <h4>{{$store.state.info.date}}  {{$store.state.info.address.name}}</h4> -->
          <router-link to="/apply">
            <span>立即报名</span>
            <i class="iconfont icon-right_circle"></i>
          </router-link>
        </div>
        <div class="banner-info__right">
          <img :src="bannerRights" alt="">
        </div>
      </div>
    </section>

    <section class="banner-bottom" id="first">
      <div class="con-intro-top">
        <com-h1 title="大会介绍" title-en="Introduction"></com-h1>
        <div class="container">
          <p>ArchSummit全球架构师峰会是InfoQ中国团队推出的重点面向高端技术管理者、架构师的技术会议，54%参会者拥有8年以上工作经验。<br>ArchSummit聚焦业界强大的技术成果，秉承“实践第一、案例为主”的原则，展示先进技术在行业中的典型实践，以及技术在企业转型、发展中的推动作用。旨在帮助技术管理者、CTO、架构师做好技术选型、技术团队组建与管理，并确立技术对于产品和业务的关键作用。</p>
          <img src="./assets/controduce.jpg" />
        </div>
      </div>
      <div class="img-box">
        <div class="line-left"></div>
        <div class="text-content">
          <h1 class="text-title">
            <span>技</span>
            <span>术</span>
            <span>促</span>
            <span>进</span>
            <span>架</span>
            <span>构</span>
            <span>师</span>
            <span>成</span>
            <span>长</span>
            </h1>
          <div class="text-sub">
            <img src="./assets/logo-color.png" alt="">
            <span class="location-text">{{`${conInfo.locationCN} · ${conInfo.year}`}}</span>
          </div>
        </div>
        <div class="line-right"></div>
      </div>
    </section>

  </header>
</div>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {
    ComH1
  },
  props: [],
  data () {
    return {
      bannerLogo: require('./assets/banner-logo.png'),
      bannerRights: require('./assets/banner-rights.png')
    }
  },
  computed: {
    ...mapState({
      conInfo: state => {
        return {
          ...state.conKeyInfo,
          address: state.info.address.name,
          conTime: `${moment(state.info.beginTime).format('M 月 D')}-${moment(state.info.endTime).format('D日')}`,
          trainingTime: state.info.beginTimeTraining ? `${moment(state.info.beginTimeTraining).format('M 月 D')}-${moment(state.info.endTimeTraining).format('D日')}` : ''
        }
      }
    })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    mouseover (key) {
      this.curKey = key
    }
  },
  filters: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../../style/variable"

.banner-top
  position: relative
  // background-color: var(--primary-color)
  .banner-bg
    vertical-align: middle
    // opacity: 0.1
    // filter: alpha(opacity=10)
  .banner-info
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -46%)
    color: #fff
    text-align: center
    .banner-info__logo
      width: 77vw
    .banner-info__location
      font-size: 20px
      margin-top: 18px
    .banner-info__key
      margin: 40px 0
      font-size: 0.9rem
      .banner-info__time
        display: flex
        justify-content: center
        flex-wrap: wrap
        .banner-info__conftime
          margin-right: 10px
        p
          line-height: 2.5
    .banner-info__btn
      // background-color: var(--primary-color)
      margin-bottom: 35px
      h4
        font-size: 14px
        text-align: center
        color: #fff
      a
        display: flex
        align-items: center
        justify-content: center
        width: 246px
        padding: .8rem 0
        margin: 0 auto
        font-size: 24px
        text-align: center
        border-radius: 4px
        color: #fff
        background-color: var(--primary-color)
        span
          margin-right: 10px
        i.iconfont
          font-size: 23px
    .banner-info__right
      width: 33vw
      margin: 0 auto

img
  width: 100%
  display: block
.instantApp
  // padding: 41px 0 46px 0
  // background-color: #0078d2
  position: relative
  h4
    font-size: 14px
    text-align: center
    color: #fff
  a
    display: flex
    align-items: center
    justify-content: center
    width: 246px
    padding: 0.8rem 0
    margin: 0 auto
    font-size: 24px
    text-align: center
    border-radius: 4px
    color: #fff
    background-color: #00a0e9
    position: absolute
    top: -45vw
    left: 50%
    transform: translateX(-50%)
    span
      margin-right: 10px
    img
      width: 22px
      height: 22px
      vertical-align: baseline

.caption
  font-weight: 500
  font-size: 22px
  text-align: center
  color: #187fc4
.desc
  display: block
  // margin-top: 11px
  font-size: 14px
  text-transform: uppercase
  text-align: center
  color: #898989

.banner-bottom
  .con-intro-top
    padding-top: 43px
    background: url('./assets/conintro.jpg') no-repeat center
    background-size: 100% 100%
    p
      font-size: 15px
      text-align: justify
      line-height: 30px
      margin-top: 22px
    img
      width: 100%
      margin-top: 17px
  > img
    width: 100%
  .img-box
    display: flex
    justify-content: space-between
    align-items: center
    width: 100vw
    height: 32vw
    padding: 6vw 7vw
    box-sizing: border-box
    background-image: url('./assets/bg.png')
    background-size: cover
    background-position: center
    background-repeat: no-repeat
    .line-left
      position: relative
      width: 1vw
      height: 100%
      background-color: #187fc2
      &::before
        content: ""
        position: absolute
        right: -12px
        width: 12px
        height: 1vw
        background-color: #187fc2
      &::after
        content: ""
        position: absolute
        bottom: 0
        right: -12px
        width: 12px
        height: 1vw
        background-color: #187fc2
    .line-right
      position: relative
      width: 1vw
      height: 100%
      background-color: #187fc2
      &::before
        content: ""
        position: absolute
        left: -12px
        width: 12px
        height: 1vw
        background-color: #187fc2
      &::after
        content: ""
        position: absolute
        bottom: 0
        left: -12px
        width: 12px
        height: 1vw
        background-color: #187fc2
    .text-content
      flex: 1 1
      height: 100%
      padding: 1vw 4vw
      display: flex
      flex-direction: column
      align-items: center
      justify-content: space-between
      .text-title
        font-size: 6vw
        font-weight: 600
        color: #187fc2
        width: 100%
        display: flex
        justify-content: space-between
        span
          font-weight: 600
      .text-sub
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        img
          width: 38vw
        .location-text
          font-size: 5vw
          font-weight: 600
    // .text-content
    //   flex: 1 1
    //   height: 100%
    //   display: flex
    //   flex-direction: column
    //   align-items: center
    //   justify-content: space-between
    //   width: 100%
    //   padding: 10px 28px
    //   box-sizing: border-box
    //   .text-title
    //     color: #187fc2
    //     width: 100%
    //     font-size: 36px
    //     font-weight: 600
    //     display: flex
    //     justify-content: space-between
    //   .text-sub
    //     display: flex
    //     justify-content: center
    //     img
    //       width: 48%
    //       margin-right: 10px
    //     .location-text
    //       font-size: 32px
    //       font-weight: 600
</style>
